import {useCallback, useEffect, useState} from 'react';

export const useImageFlip = (canvas) => {
  const [flipX, setFlipX] = useState(false);
  const [flipY, setFlipY] = useState(false);

  useEffect(() => {
    const activeObj = canvas?.getActiveObject();
    if (activeObj?.type === 'uYOImage') {
      setFlipX(activeObj.flipX || false);
      setFlipY(activeObj.flipY || false);
    }
  }, [canvas]);

  const handleFlipX = useCallback(() => {
    const activeObj = canvas.getActiveObject();
    if (activeObj && activeObj.type === 'uYOImage') {
      const newFlipX = !activeObj.flipX;
      activeObj.set({flipX: newFlipX});
      setFlipX(newFlipX);
      canvas.renderAll();
      canvas.fire('object:modified');
    }
  }, [canvas]);

  const handleFlipY = useCallback(() => {
    const activeObj = canvas.getActiveObject();
    if (activeObj && activeObj.type === 'uYOImage') {
      const newFlipY = !activeObj.flipY;
      activeObj.set({flipY: newFlipY});
      setFlipY(newFlipY);
      canvas.renderAll();
      canvas.fire('object:modified');
    }
  }, [canvas]);

  return {
    flipX,
    flipY,
    handleFlipX,
    handleFlipY,
  };
};
